import React from 'react';
import { useMsal } from '@azure/msal-react';
import { Ban, LogOut, Mail } from 'lucide-react';

export default function TenantSuspendedPage() {
  const { instance } = useMsal();

  const handleSignOut = () => {
    instance.logoutRedirect();
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 relative z-[1]">
      <div className="glass-card p-8 max-w-md w-full text-center">
        <div className="w-20 h-20 rounded-full bg-red-500/20 flex items-center justify-center mx-auto mb-6">
          <Ban className="w-10 h-10 text-red-400" />
        </div>
        
        <h1 className="text-2xl font-bold text-white mb-2">Tenant Suspended</h1>
        
        <p className="text-white/70 mb-6">
          Your organisation's access to ALICE has been suspended. 
          Please contact your administrator for more information.
        </p>
        
        <div className="bg-white/5 rounded-lg p-4 mb-6">
          <p className="text-white/50 text-sm mb-2">Need assistance?</p>
          <a 
            href="mailto:support@beyondapplications.io" 
            className="flex items-center justify-center gap-2 text-alice-cyan hover:underline"
          >
            <Mail className="w-4 h-4" />
            support@beyondapplications.io
          </a>
        </div>
        
        <button
          onClick={handleSignOut}
          className="w-full flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-white py-3 px-6 rounded-lg transition-colors"
        >
          <LogOut className="w-4 h-4" />
          Sign Out
        </button>
      </div>
    </div>
  );
}
